import React, { useEffect, useReducer } from 'react';
import { KEY_ACCESS_TOKEN, KEY_REFRESH_TOKEN } from '../Constants/constant';

export const initialState = {
  isAuthenticated: false,
  user: null,
  search: null,
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      console.log(action);
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      if (action.payload.programSearch) {
        localStorage.setItem('programSearch', action.payload.programSearch);
      }
      localStorage.setItem(KEY_ACCESS_TOKEN, action?.payload?.user?.accessToken?.accessToken?.token);
      localStorage.setItem(KEY_REFRESH_TOKEN, action?.payload?.user?.refreshToken?.refreshToken?.token);
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
        search: action.payload.search,
        programSearch: action.payload.programSearch,
      };
    case 'LOGOUT':
      localStorage.clear();
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        search: null,
        programSearch: null,
      };
    default:
      return state;
  }
};

export const AuthContext = React.createContext();

export const AuthContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  //TODO: Enable for loggin in user once token is store in local storage
  useEffect(() => {
    const user = JSON?.parse(localStorage?.getItem('user'));
    if (user) {
      dispatch({
        type: 'LOGIN',
        payload: {
          user,
        },
      });
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};